/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：176
 */

module.exports = {
  hide: "style_hide__2Fb-b",
  "coco-widget-wrapper": "style_coco-widget-wrapper__60dp3",
  "coco-child-widget": "style_coco-child-widget__1rhRZ",
  "coco-child-widget-selected": "style_coco-child-widget-selected__3Qn6a",
  "coco-child-widget-full": "style_coco-child-widget-full__2vcm6",
  webViewWidget: "style_webViewWidget__2AMFy",
  maskVisible: "style_maskVisible__1Bd0C",
  mask: "style_mask__2gQOx",
  placeholderPoster: "style_placeholderPoster__1guUs",
  header: "style_header__2WxRg",
  main: "style_main__3iiob",
  fail: "style_fail__1LQHr",
  image: "style_image__1Z0Ho",
  title: "style_title__2SqSr",
  label: "style_label__2uiTu",
  loaderBox: "style_loaderBox__3QvTQ",
  loader: "style_loader__1TGFb",
  load2: "style_load2__2fRD8"
}
